import React from "react";
import { LoadioArtistPreviewAlbumTemplate } from "themes/administration/loadio/components";
import { LoadioArtistPreviewAlbumViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioArtistPreviewAlbumViewStore(rootStore, componentProps),
    "loadioArtistPreviewAlbumViewStore"
)
class LoadioArtistPreviewAlbum extends React.Component {
    render() {
        return <LoadioArtistPreviewAlbumTemplate {...this.props} />;
    }
}

export default LoadioArtistPreviewAlbum;
